import { apiRequest } from './apiClient';
export const fetchJobs = async () => (await apiRequest('/jobs')).data;
export const fetchDeletedJobs = async () => (await apiRequest('/jobs?deleted=true')).data;
function jobBody(job) {
  const body = new FormData();
  Object.entries(job).forEach(([key, value]) => {
    if (value !== undefined && value !== null) body.append(key, value instanceof File ? value : String(value));
  });
  return body;
}
export const createJob = async job => (await apiRequest('/jobs', { method: 'POST', body: jobBody(job) })).data;
export const updateJob = async (id, job) => (await apiRequest(`/jobs/${id}`, { method: 'PATCH', body: jobBody(job) })).data;
export const deleteJob = async id => (await apiRequest(`/jobs/${id}`, { method: 'DELETE' })).data;
export const bulkUploadJobs = async file => { const body = new FormData(); body.append('file', file); return apiRequest('/jobs/bulk-upload', { method: 'POST', body }); };
export const fetchBulkUploadTemplate = async () => apiRequest('/jobs/bulk-template');
export const updateJobsStatus = async (id, status) => (await apiRequest(`/jobs/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) })).data;
export const bulkUpdateStatus = (ids, status) =>
  apiRequest(`/jobs/bulk-status`, { method: 'PATCH', body: JSON.stringify({ ids, status }) });
export const restoreJobs = ids => apiRequest('/jobs/bin/restore', { method: 'PATCH', body: JSON.stringify({ ids }) });
export const permanentlyDeleteJobs = ids => apiRequest('/jobs/bin/permanent', { method: 'DELETE', body: JSON.stringify({ ids }) });
